// Fiscal Server commands, their responses and errors are defined in the shared tax register
// package.
export { TaxError, TaxErrorEnum } from 'tax-register-core';
export {
  CheckExtCommand,
  LastShiftTotalsCommand,
  ObjectsCommand,
  OperatorsCommand,
  ServerStateCommand,
  ShiftDocumentsCommand,
  ShiftsCommand,
  TransactionsRegistrarStateCommand,
  ZRepExtCommand,
} from 'tax-register-core';
export type {
  CheckExtCommandOptions,
  DocumentResponse,
  ObjectsResponse,
  OperatorItem,
  ResponseOperators,
  ServerStateResponse,
  ShiftDocumentsResponse,
  ShiftItem,
  ShiftsResponse,
  TaxDocumentResponseType,
  TaxObjectItem,
  TransactionsRegistrarItem,
} from 'tax-register-core';

// Fiscal Server models are defined in the shared tax register package as well.
import {
  DocumentItem,
  TaxDocumentSubType,
  TaxDocumentType,
  isOfflineSequenceActive,
} from 'tax-register-core';
import type {
  CHECKHEAD,
  LastShiftTotalsResponse,
  ShiftTotals,
  ShiftTotalsCash,
  ShiftTotalsCurrency,
  ShiftTotalsOrderType,
  ShiftTotalsPayForm,
  ShiftTotalsTax,
  TaxObject,
  TotalsCurrencyDetails,
  TransactionsRegistrar,
  TransactionsRegistrarStateResponse,
} from 'tax-register-core';
export {
  DocumentItem,
  TaxDocumentSubType,
  TaxDocumentType,
  isOfflineSequenceActive,
};
export type {
  CHECKHEAD,
  LastShiftTotalsResponse,
  ShiftTotals,
  ShiftTotalsCash,
  ShiftTotalsCurrency,
  ShiftTotalsOrderType,
  ShiftTotalsPayForm,
  ShiftTotalsTax,
  TaxObject,
  TotalsCurrencyDetails,
  TransactionsRegistrar,
  TransactionsRegistrarStateResponse,
};

export class ZREP {
  // ZREPHEAD: ZREPHEAD;
  // ZREPREALIZ: ZREPREALIZ;
  // ZREPRETURN: ZREPRETURN;
  // ZREPBODY: ZREPBODY;
}

export class CHECK {
  CHECKHEAD: CHECKHEAD;
}
